var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link.length > 0)?_c('router-link',{staticClass:"btn",attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.text))]):_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.buttonClicked}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }